exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-layer {\n  width: 100%;\n  text-align: center;\n  height: 300px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/app/components/image-cropper-plugins/image-cropper-plugins.component.scss
// module id = ../../../../../ng-src/app/components/image-cropper-plugins/image-cropper-plugins.component.scss
// module chunks = main